"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var Observable_1 = require("rxjs/Observable");
var bufferCount_1 = require("rxjs/operators/bufferCount");
var concatMap_1 = require("rxjs/operators/concatMap");
require("rxjs/add/observable/from");
function probinator(hashedBlob$, _a) {
    var batchSize = _a.batchSize, prober = _a.prober;
    return hashedBlob$.pipe(bufferCount_1.bufferCount(batchSize), concatMap_1.concatMap(function (hashedBlobs) {
        return prober(hashedBlobs).then(function (probes) {
            return hashedBlobs.map(function (hashedBlob, index) { return (tslib_1.__assign({}, hashedBlob, { exists: probes[index] })); });
        });
    }), concatMap_1.concatMap(function (probedBlobs) { return Observable_1.Observable.from(probedBlobs); }));
}
exports.probinator = probinator;
//# sourceMappingURL=probinator.js.map